import { render } from "./articles-association.vue?vue&type=template&id=f90896ae&scoped=true"
import script from "./articles-association.vue?vue&type=script&lang=js"
export * from "./articles-association.vue?vue&type=script&lang=js"

import "./articles-association.vue?vue&type=style&index=0&id=f90896ae&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f90896ae"]])

export default __exports__